// src/components/common/IconCartAddButton.tsx
import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCartPlus } from '@/icons';
import './IconCartAddButton.css';

interface IconCartAddButtonProps {
  onClick: () => void;
  title?: string;
  disabled?: boolean;
  className?: string;
}

const IconCartAddButton: React.FC<IconCartAddButtonProps> = ({
  onClick,
  title,
  disabled = false,
  className = '',
}) => {
  return (
    <button
      className={`icon-cart-add-button ${className}`}
      onClick={onClick}
      title={title}
      disabled={disabled}
    >
      <FontAwesomeIcon icon={faCartPlus} />
    </button>
  );
};

export default IconCartAddButton;
